import React, { useEffect, useState } from 'react';
import { LogOut, UserCircle2 } from 'lucide-react';
import SparePartsCatalog from './SparePartsCatalog';

export default function SparePartsPortal({ customer, onLogout }) {
  const [cssReady, setCssReady] = useState(false);

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = '/spares-site.css';
    link.id = 'spares-site-css';
    link.onload = () => setCssReady(true);
    link.onerror = () => setCssReady(true);
    document.head.appendChild(link);
    return () => { document.getElementById('spares-site-css')?.remove(); };
  }, []);

  if (!cssReady) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', gap: 16, background: 'linear-gradient(160deg, #0b1524 0%, #0e2036 55%, #113052 100%)',
        color: '#94a3b8', fontFamily: 'system-ui, sans-serif',
      }} data-testid="portal-loading">
        <img src="/images/kiel-logo.png" alt="Kiel Americas" style={{ height: 40, objectFit: 'contain' }} />
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13 }}>
          <span style={{
            width: 16, height: 16, border: '2px solid rgba(148,163,184,0.3)', borderTopColor: '#22d3ee',
            borderRadius: '50%', display: 'inline-block', animation: 'spin 0.8s linear infinite',
          }} />
          Loading spare parts catalog…
        </div>
        <style>{'@keyframes spin { to { transform: rotate(360deg); } }'}</style>
      </div>
    );
  }

  return (
    <div data-testid="spare-parts-portal">
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 14,
        padding: '6px 18px', background: '#0b1524', color: '#cbd5e1', fontSize: 12,
        fontFamily: 'system-ui, sans-serif', position: 'sticky', top: 0, zIndex: 60,
        borderBottom: '1px solid rgba(255,255,255,0.08)',
      }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }} data-testid="portal-user-email">
          <UserCircle2 size={14} /> {customer?.name ? `${customer.name} · ` : ''}{customer?.email}
        </span>
        <button onClick={onLogout}
          style={{
            display: 'flex', alignItems: 'center', gap: 5, background: 'rgba(255,255,255,0.08)',
            border: '1px solid rgba(255,255,255,0.12)', color: '#e2e8f0', borderRadius: 999,
            padding: '4px 12px', fontSize: 11, fontWeight: 600, cursor: 'pointer',
          }}
          data-testid="portal-logout-btn">
          <LogOut size={12} /> Sign out
        </button>
      </div>
      <SparePartsCatalog />
    </div>
  );
}
